import { render } from "./Step2.vue?vue&type=template&id=8b4a3438&ts=true"
import script from "./Step2.vue?vue&type=script&lang=ts"
export * from "./Step2.vue?vue&type=script&lang=ts"

import "./Step2.vue?vue&type=style&index=0&id=8b4a3438&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__